<template>
  <div class="my">
    <header>
      我的
    </header>
    <section>
      <!-- 会员卡 -->
      <div class="club-card">
        <!-- 信息 -->
        <div class="card-information">
          <!-- 头像 -->
          <p class="head-portrait">
            <img src="../../assets/images/head-portrait.jpg" alt="">
          </p>
          <p class="card-name">
            张三丰
          </p>
          <p class="card-ewm" @click="$router.replace('/share')">
            <img src="../../assets/images/my-img/share.png" alt="">
          </p>
        </div>
        <!-- 订单详情 -->
        <div class="order-details">
          <p>
            NO.101000001
          </p>
        </div>
        <div class="period-of-validity">
          <p>
            有效期：永久使用
          </p>
        </div>
        <!-- 等级 -->
        <div class="card-grade">
          <p>
            <span>
              lv1
            </span>
          </p>
          <p>
            <span>
              lv2
            </span>
          </p>
          <p>
            <span>
              lv3
            </span>
          </p>
          <p>
            <span>
              lv4
            </span>
          </p>
          <p>
            <span>
              lv5
            </span>
          </p>
          <!-- 进度条 -->
          <van-progress 
            :percentage="card_grade" 
            stroke-width="2"
            pivot-text=""
            color="#FFFFFFFF"
          />
        </div>
      </div>
      <!-- 佣金 积分 -->
      <div class="my-asset">
        <div class="my-brokerage">
          <p class="p1">
            我的佣金
          </p>
          <p class="p2">
            0
          </p>
        </div>
        <div class="color">
        </div>
        <div class="my-integral" @click="$router.replace('/pay-record')">
          <p class="p1">
            我的账户
          </p>
          <p class="p2">
            0
          </p>
        </div>
      </div>
      <!-- 菜单 -->
      <div class="my-menu">
          <dl @click="payBtn">
            <dt>
              <img src="../../assets/images/my-img/top-up.png" alt="">
            </dt>
            <dd>充值</dd>
          </dl>
          <dl @click="orderBtn">
            <dt>
              <img src="../../assets/images/my-img/my-order.png" alt="">
            </dt>
            <dd>我的订单</dd>
          </dl>
          <dl @click="$router.replace('/perfect')">
            <dt>
              <img src="../../assets/images/my-img/perfection.png" alt="">
            </dt>
            <dd>完善信息</dd>
          </dl>
          <dl @click="$router.replace('/card-rights')">
            <dt>
              <img src="../../assets/images/my-img/rights-and-interests.png" alt="">
            </dt>
            <dd>卡权益</dd>
          </dl>
          <dl @click="$router.replace('/apply-partner')">
            <dt>
              <img src="../../assets/images/my-img/hehuo.png" alt="">
            </dt>
            <dd>申请合伙人</dd>
          </dl>
          <dl @click="$router.replace('/fans')">
            <dt>
              <img src="../../assets/images/my-img/bean-vermicelli.png" alt="">
            </dt>
            <dd>粉丝管理</dd>
          </dl>
        <div class="my-menu-t">

        </div>
        <div class="my-menu-b">
        </div>
      </div>
    </section>
    <footer>
      <tabar></tabar>
    </footer>
  </div>
</template>
<script>

import Vue from 'vue';
import { Progress } from 'vant';
Vue.use(Progress);
import tabar from '../../components/tabar/tabar'

export default {
  data(){
    return{
      card_grade:'30', // 进度条
      url:''
    }
  },
  created(){
    this.url = this.$route.path
    console.log(this.url)
    let parm ="url=http://dmw5zf.natappfree.cc";
    this.$axios.get("/api/user/public/login?"+parm).then((res) => {
        console.log(res)
    })
  },
  components:{
    tabar
  },
  methods:{
    payBtn(){
      this.$router.replace('/pay-success')
    },
    orderBtn(){
      this.$router.replace('/order-list')
    }
  }
}
</script>
<style lang="less" scoped>
  .my{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    header{
      width: 100%;
      height: 4.78rem;
      line-height: .88rem;
      text-align: center;
      font-family: PingFangSC-Regular;
      color: #FFFFFF;
      font-size: .36rem;
      // background: linear-gradient(310deg,#232323 0%,#4A4A4A 57%,#333333 100%);
      background-image: url(../../assets/images/my-img/black.png);
      background-size: 100% 4.78rem;
    }
    section{
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-top: -3.69rem;
      // .back-img{
      //   width: 100%;
      //   // background-image: url(../../assets/images/home-img/black.png);
      //   // background-size: 7.5rem;
      //   // background: linear-gradient(310deg,#232323 0%,#4A4A4A 57%,#333333 100%);

      // }
      // 会员卡
      .club-card{
        width: 6.9rem;
        height: 3.32rem;
        border-radius: .2rem;
        background:linear-gradient(310deg,rgba(211,160,96,1) 0%,rgba(251,216,134,1) 57%,rgba(222,172,103,1) 100%);
        margin: 0 auto;
        box-shadow: 0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
        overflow: hidden;
        // margin-top: -2.1rem;
        // 信息
        .card-information{
          width: 100%;
          height: .72rem;
          display: flex;
          align-items: center;
          margin-top: .2rem;
          // 头像
          .head-portrait{
            width: .72rem;
            height: .72rem;
            border-radius: 50%;
            img{
              width: .72rem;
              height: .72rem;
              border-radius: 50%;
              margin-left: .2rem;
              // margin-top: .2rem;
            }
          }
          // 名字
          .card-name{
            font-family: PingFang-SC-Heavy;
            font-size: .36rem;
            color: #734913;
            margin-left: .4rem;
            // margin-top: .3rem;
            font-weight: bold;
          }
          // 扫码
          .card-ewm{
            img{
              width: .36rem;
              height: .32rem;
              margin-left: 4rem;
            }
          }
        }
        // 订单详情
        .order-details{
          width: 100%;
          height: .4rem;
          p{
            display: flex;
            margin-left: 1.12rem;
            align-items: center;
            font-family: PingFang-SC-Medium;
            color: #734913;
            font-size: .28rem;
          }
        }
        .period-of-validity{
          width: 100%;
          height: .4rem;
          p{
            display: flex;
            margin-left: 1.12rem;
            align-items: center;
            font-family: PingFang-SC-Medium;
            color: #734913;
            font-size: .28rem;
          }
        }
        // 会员等级
        .card-grade{
          width: 6.52rem;
          height: .02rem;
          margin: 0 auto;
          margin-top: .74rem;
          position: relative;
          // 等级标签
          p{
            display: inline-block;
            width: .6rem;
            height: .22rem;
            background: #ffffff;
            font-family: PingFang-SC-Medium;
            color: #734913;
            font-size: .16rem;
            text-align: center;
            line-height: .22rem;
            border-radius: .08rem;
            position: absolute;
            z-index: 1;
            span{
              display: inline-block;
              // -webkit-transform: scale(0.8);
            }
            &:first-child{
              left: .42rem;
              top: -.11rem;
            }
            &:nth-child(2){
              left: 1.82rem;
              top: -.11rem;
            }
            &:nth-child(3){
              left: 3.2rem;
              top: -.11rem;
            }
            &:nth-child(4){
              left: 4.6rem;
              top: -.11rem;
            }
            &:nth-child(5){
              left: 6rem;
              top: -.11rem;
            }
          }
          .van-progress{
            background: #734913;
          }
        }
      }
      // 佣金 积分
      .my-asset{
        width: 100%;
        height: 2rem;
        margin-top: .376rem;
        display: flex;
        border-bottom: .2rem #F4F4F4 solid;
        .my-brokerage{
          width: 49.8%;
          text-align: center;
          display: flex;
          flex-direction: column;
          .p1{
            font-family: PingFang-SC-Medium;
            color: #333333;
            font-size: .28rem;
            font-weight: 600;
            margin-top: .38rem;
          }
          .p2{
            font-family: SFUIText-Regular;
            color: #333333;
            font-size: .6rem;
            line-height: .6rem;
            margin-top: .1rem;
          }
        }
        .my-integral{
          width: 49.8%;
          text-align: center;
          display: flex;
          flex-direction: column;
          .p1{
            font-family: PingFang-SC-Medium;
            color: #333333;
            font-size: .28rem;
            font-weight: 600;
            margin-top: .38rem;
          }
          .p2{
            font-family: SFUIText-Regular;
            color: #333333;
            font-size: .6rem;
            line-height: .6rem;
            margin-top: .1rem;
          }
        }
        .color{
          width: 0.4%;
          height: .86rem;
          background: #E4E4E4;
          margin-top: .58rem;
        }
      }
      // 菜单
      .my-menu{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        dl{
          width: 33%;
          margin-top: .4rem;
          dt{
            width: .96rem;
            height: .96rem;
            margin: 0 auto;
            img{
              width: .96rem;
              height: .96rem;
            }
          }
          dd{
            font-family: PingFang-SC-Bold;
            color: #333333;
            font-size: .28rem;
            text-align: center;
            font-weight: bold;
            margin-top: .1rem;
          }
        }
        // .my-menu-t{
        //   width: 5.56rem;
        //   margin: 0 auto;
        //   margin-top: .4rem;
        //   display: flex;
        //   dl{
        //     &:nth-child(2){
        //       margin-left: 1.2rem;
        //     }
        //     &:last-child{
        //       margin-left: 1.2rem;
        //     }
        //   }
        // }
        // .my-menu-b{
        //   width: 5.56rem;
        //   margin: 0 auto;
        //   margin-top: .4rem;
        //   display: flex;
        //   dl{
        //     &:last-child{
        //       margin-left: 1.2rem;
        //     }
        //   }
        // }
      }
    }
  }
</style>